<template>
  <div ref="chart">
    <Chart :id="id" :extend-data="extendData" :height="height" :option="option" :width="width" />
  </div>
</template>

<script>
import Chart from '@/components/echarts/Chart'

export default {
  name: 'LineChartPue1',
  components: { Chart },
  props: {
    data: {},
    extendData: null,
    name: null,
    colorList: {
      type: Array,
      default: () => {
        return []
      }
    }
  },
  data() {
    return {
      id: 'LineChartPue1',
      width: '100%',
      height: '100%',
      option: {}
    }
  },
  watch: {
    data() {
      this.getOption()
    }
  },
  mounted() {
    this.getOption()
  },
  methods: {
    getOption: function() {
      const labelColor = 'rgba(232,232,232,.2)'
      let colorList
      if (this.colorList.length > 0) {
        colorList = this.colorList
      } else {
        colorList = ['#FDDC60','#FE8279', '#13A4FF', '#F95453']
      }
      this.option = {
        grid: {
          top: '5%',
          right: '10%',
          left: '10%',
          bottom: '32%'
        },
        xAxis: [{
          type: 'category',
          data: this.data.time,
          axisLine: {
            show: false
          },
          axisTick: {
            show: false
          },
          axisLabel: {
            interval: 0,
            textStyle: {
              color: '#FAFAFA'
            },
            // 默认x轴字体大小
            fontSize: 12,
            // margin:文字到x轴的距离
            margin: 15,
            rotate: 45
          },
          splitLine: {
            lineStyle: {
              type: 'solid',
              color: labelColor
            }
          },
          boundaryGap: false
        }],
        yAxis: [{
          type: 'value',
          axisTick: {
            show: false
          },
          axisLine: {
            show: true,
            lineStyle: {
              color: labelColor
            }
          },
          axisLabel: {
            textStyle: {
              color: '#FAFAFA'
            }
          },
          splitLine: {
            lineStyle: {
              type: 'solid',
              color: labelColor
            }
          }
        }],
        series: [{
          type: 'line',
          data: this.data.value,
          symbolSize: 1,
          symbol: 'circle',
          smooth: true,
          yAxisIndex: 0,
          showSymbol: false,
          lineStyle: {
            normal: {
              color: colorList[0]
            }
          },
          itemStyle: {
            normal: {
              color: colorList[0],
              borderColor: colorList[0]
            }
          }
        }]
      }
    }
  }
}
</script>

<style scoped>

</style>
